import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/**
 * The way back to the wine list, above the heading of every page that sits
 * below it — a wine, and the form that registers or corrects one.
 *
 * The list is where a cellar is worked from, so every page reachable from it
 * carries one step back to it in the same place, in the same words. Above the
 * heading rather than beside it, because the heading rows down here are
 * already carrying something of their own: the wine's number, or the wine a
 * correction belongs to.
 *
 * It is rendered before anything is known — while the wine is being fetched,
 * and when fetching it failed. A page that cannot show what it was asked for
 * is exactly the page nobody should be stranded on, and a back link that
 * appears only on success is missing precisely when it is needed.
 *
 * No arrow. Design-direction.md says the word is the destination.
 */
export function BackToWines({ cellarId }: { cellarId: string }) {
  const { t } = useTranslation();

  return (
    <p className="mb-4">
      <Link
        to={`/kallare/${cellarId}`}
        className="text-accent text-sm underline-offset-4 hover:underline"
      >
        {t("wines.title")}
      </Link>
    </p>
  );
}
